import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router/index.js'
import { http } from '@/utils/http'
import { helloHttp } from '@/utils/helloHttp'
import { Toast, List, Dialog, Popup, Picker, DatetimePicker, Area, Lazyload, Field, Button, CellGroup, CountDown, ImagePreview } from 'vant'
import VueCookies from 'vue-cookies'
// import vConsole from 'vconsole'

// import { setCookie, getCookie } from '@/utils/tools'
// setCookie('session', 'ded45ad08f514acaaf55773d27fade82')

Vue.config.productionTip = false
Vue.config.ignoredElements = ['wx-open-launch-weapp']
Vue.prototype.$http = http
Vue.prototype.$helloHttp = helloHttp
Toast.setDefaultOptions({ duration: 3000 })

Vue.use(Toast).use(Dialog).use(List).use(Popup).use(Picker).use(DatetimePicker).use(Area).use(Lazyload)
  .use(Field).use(Button).use(CellGroup).use(CountDown).use(ImagePreview).use(VueCookies)

// eslint-disable-next-line no-new
// new vConsole()

Vue.filter('formatTime', (timestamp) => {
  try {
    const date = new Date(timestamp)
    let month = date.getMonth() + 1
    month = month < 10 ? '0' + month : month
    let day = date.getDate()
    day = day < 10 ? '0' + day : day
    let hour = date.getHours()
    hour = hour < 10 ? '0' + hour : hour
    let minutes = date.getMinutes()
    minutes = minutes < 10 ? '0' + minutes : minutes
    let seconds = date.getSeconds()
    seconds = seconds < 10 ? '0' + seconds : seconds
    return `${date.getFullYear()}-${month}-${day} ${hour}:${minutes}:${seconds}`
  } catch (err) {
    return ''
  }
})
window.app = new Vue({
  store,
  router,
  render: h => h(App),
  data () {
    return {
      isLoading: false
    }
  },
  methods: {
    openLoading () {
      this.isLoading = true
    },
    closeLoading () {
      this.isLoading = false
    }
  }
}).$mount('#app')
